import React, {Fragment} from 'react';
import {
    Card,
    Table,
    Menu,
    Dropdown,
    Space,
    Input,
    Row,
    Button,
    Typography,
    Modal,
    Form,
    Select,
    Checkbox,
    TimePicker,
    InputNumber,
    notification,
    Spin, Avatar
} from "antd";

import {
    DownOutlined,
    DownloadOutlined,
    DeleteOutlined,
    PlusOutlined,
    EuroCircleOutlined,
    LinkOutlined,
    MinusOutlined
} from '@ant-design/icons';

import ApiService from "../services/ApiService"

import IntlMessage from "../components/util-components/IntlMessage";
import {API_BASE_URL} from "../configs/AppConfig";
import ModalPromesse from "./ModalPromesse";
import ModalPayement from "./ModalPayement";
import ResponsiveTable from "../components/ResponsiveTable";
import Index from "../views/app-views/contact/Fiche";
import RestrictedAlert from "../components/permissions/RestrictedAlert";
import {isMobile} from "react-device-detect";
import {connect} from "react-redux";


const {Search} = Input;
const {Text} = Typography;
const {Option} = Select;


class ModalAcl extends React.Component {

    constructor(props) {
        super(props);
        props.getRef(this)
    }

    initialState = {
        visible: false,
        id: null,
        type:null,
        defaultData:null,
    };

    state=this.initialState
    async show(id,type,data={}) {
        console.log("EDIT ACL ", id,type)

        this.setState({visible: true, id: id,type:type,defaultData:{...data}})

    }

    close() {
        this.setState(this.initialState)
    }

    async onSubmit(data)
    {
        const accessWhiteList=data.accessWhiteList || []
        const accessBlackList=data.accessBlackList || []


        var res = await ApiService.post("/acl/edit", {id:this.state.id,type:this.state.type,accessWhiteList:accessWhiteList,accessBlackList:accessBlackList})
        console.log(res)

        if (res.success) {
            notification.success({
                message: this.state.edit ? (<IntlMessage id="success.edit"/>) : (<IntlMessage id="success.add"/>)
            })

            this.close()
            if (this.props.onFinish) {
                this.props.onFinish()
            }
        } else {
            notification.success({
                message: this.state.edit ? (<IntlMessage id="error.edit"/>) : (<IntlMessage id="error.add"/>)
            })
        }
    }

    render()
    {

        const accessList=(this.props.org.accessList || []).filter(i=>i.type!=="ADMIN")

        return (
            <Fragment>
                <Modal style={{marginTop: 0, top: isMobile ? 20 : undefined}} width={"100%"}
                       title={"Modifier les permissions"} open={this.state.visible} destroyOnClose closable footer={null}
                       onCancel={() => this.close()}>

                    <Form
                        initialValues={this.state.defaultData}
                        onFinish={(data) => this.onSubmit(data)}
                    >

                        <Form.Item label={"Uniquement à (Liste blanche)"} name={"accessWhiteList"}>
                            <Select mode={"multiple"}>
                                {accessList.map(al=>
                                {
                                    let bgColor = al.color || "#000"
                                    let shortName = al.shortName || al?.prenom.slice(0, 3).toUpperCase()
                                    return (
                                        <Select.Option value={al.id}>
                                            <Space>
                                                <Avatar size={"small"}
                                                        style={{backgroundColor: bgColor, color: "#FFF"}}>{shortName}</Avatar>
                                                <span>{al.prenom} {al.nom}</span>
                                            </Space>
                                        </Select.Option>
                                    )
                                })}

                            </Select>
                        </Form.Item>

                        <Form.Item label={"Sauf à (Liste noire)"} name={"accessBlackList"}>
                            <Select mode={"multiple"}>
                                {accessList.map(al=>
                                {
                                    let bgColor = al.color || "#000"
                                    let shortName = al.shortName || al?.prenom.slice(0, 3).toUpperCase()
                                    return (
                                        <Select.Option value={al.id}>
                                            <Space>
                                                <Avatar size={"small"}
                                                        style={{backgroundColor: bgColor, color: "#FFF"}}>{shortName}</Avatar>
                                                <span>{al.prenom} {al.nom}</span>
                                            </Space>
                                        </Select.Option>
                                    )
                                })}
                            </Select>
                        </Form.Item>


                        <Form.Item style={{display: "flex", justifyContent: "flex-end"}}>
                            <Button type="primary" htmlType="submit" loading={this.state.loading}>
                                Valider
                            </Button>
                        </Form.Item>
                    </Form>
                </Modal>
            </Fragment>

        )
    }
}

const mapStateToProps = (state) => {
    return {
        org: state.auth.org,
        access: state.auth.access,
    }
};

export default connect(mapStateToProps)(React.memo(ModalAcl));
